import React from 'react'
import Select from 'react-select'
import { CAROUSEL_SIZE_OPTIONS, CarouselWidgetTypeCode } from '../../../constants/widgetTypes'
import formStyles from '../../../styles/forms.module.scss'
import selectStyles from '../../../styles/react-select.module.scss'
import CardCarouselEditor from './CardCarouselEditor'
import CarouselPreviewPane from './CarouselPreviewPane'

// Config shared by all card-carousel widget types. The card size/orientation
// variant is the widget_type itself (migration 85), not a field here — it's
// chosen via the "Size & orientation" selector below, which changes widget_type.
export interface CarouselMetadata {
  title?: string
  sources?: string[]
  filters?: Record<string, unknown>
  sort?: string
  limit?: number
  ended_grace_minutes?: number
  card_fields?: string[]
  show_more?: { label: string; path: string }
  items?: Array<Record<string, unknown>>
  [key: string]: unknown
}

interface CarouselEditorProps {
  metadata: CarouselMetadata
  onChange: (metadata: CarouselMetadata) => void
  /** The carousel's current widget_type — the selected size/orientation variant. */
  widgetType: string
  /** Change the widget_type (size/orientation). Absent in read-only contexts. */
  onWidgetTypeChange?: (code: string) => void
  widgetId?: string
}

const SIZE_OPTIONS = CAROUSEL_SIZE_OPTIONS.map(o => ({ value: o.code, label: o.label }))

const CarouselEditor: React.FC<CarouselEditorProps> = ({ metadata, onChange, widgetType, onWidgetTypeChange }) => {
  return (
    <>
      <div className={formStyles.fieldGroup}>
        <label>Size &amp; orientation</label>
        <Select
          value={SIZE_OPTIONS.find(o => o.value === widgetType) ?? null}
          onChange={(opt) => opt && onWidgetTypeChange?.(opt.value as CarouselWidgetTypeCode)}
          options={SIZE_OPTIONS}
          isDisabled={!onWidgetTypeChange}
          className={selectStyles.reactSelect}
          classNamePrefix="react-select"
        />
        <p className={formStyles.hint}>All sizes share the same content and settings below.</p>
      </div>

      <CardCarouselEditor metadata={metadata} onChange={onChange} />
      <CarouselPreviewPane metadata={metadata} />
    </>
  )
}

export default CarouselEditor
